// Central site configuration — single source of truth for domain & contact.
export const SITE_URL = "https://lotusgruppen.dk";

export const SITE = {
  name: "Lotusgruppen",
  legalName: "Lotusgruppen ApS",
  url: SITE_URL,
  contact: {
    phone: "26 81 08 08",
    phoneRaw: "+4526810808",
    email: "Kontakt@lotusgruppen.dk",
    company: "Lotusgruppen ApS",
    street: "Peter Sabroes Gade 7, 2th",
    postalCode: "2450",
    city: "København SV",
    country: "DK",
  },
};

// Feature flags. Partner logos stay hidden until written display consent
// is documented (see /app/memory/logo_review.md).
export const showPartnerLogos = false;

// Central route map — Danish canonical paths. English = "/en" + path.
export const ROUTES = [
  { key: "home", path: "/" },
  { key: "ydelser", path: "/ydelser" },
  { key: "indsatser", path: "/indsatser" },
  { key: "findforloeb", path: "/find-forloeb" },
  { key: "kommuner", path: "/kommuner-og-kriminalforsorgen" },
  { key: "akut", path: "/akut-projekter" },
  { key: "udsatte", path: "/udsatte" },
  { key: "adhd", path: "/adhd" },
  { key: "autisme", path: "/autisme" },
  { key: "kontakt", path: "/kontakt" },
  { key: "privatliv", path: "/privatliv" },
  { key: "cookies", path: "/cookies" },
];

export const PRODUCT_SLUGS = [
  "lotus-afklaring",
  "lotus-72",
  "lotus-stabil-90",
  "lotus-180",
  "lotus-fastholdelse",
];

export const isEnglishPath = (pathname) =>
  pathname === "/en" || pathname.startsWith("/en/");

// Convert any path to its equivalent path in the target language.
export const toLangPath = (pathname, target) => {
  let da = pathname;
  if (da === "/en") da = "/";
  else if (da.startsWith("/en/")) da = da.slice(3);
  if (!da.startsWith("/")) da = "/" + da;
  if (target === "en") return da === "/" ? "/en" : "/en" + da;
  return da;
};

export const toDaPath = (pathname) => toLangPath(pathname, "da");
